<template>
    <div class="panel panel-primary" id="rightDiv2" v-if="recentUsageLoaded">
        <div class="panel-heading">
            <h3 class="panel-title">{{ $t("message.recentUsage") }}</h3>
        </div>
        <div class="panel-body noform">
            <div id="container"></div>
            <highcharts class="chart" :options="chartOptions" ref="recentUsageChart"></highcharts>
            <div class="text-center">
                <p class="font-size-sm">{{ $t("message.usageChartsFooterMessage") }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import chartHelper from '@/assets/js/chartHelper';

export default {
    name: 'RecentUsage',
    data() {
        return {
            chartOptions: [],
            recentUsageLoaded: false
        }
    },
    mounted() {
        // Get recent usage data for last 7 days
        axios({
            method: "GET",
            url: this.$httpAxiosBaseUrl() + "Home/GetDollarChartDataForLast7Days?date=" + new Date().getTime()
        }).then(result => {
            var response = result.data;
            if (response !== '') {
                var categoriesData = response.Categories;
                var stackedSeriesData = response.AllChartData;

                this.chartOptions = chartHelper.getDollarChartOptions('', chartHelper.ChartType.SevenDays, '', categoriesData, stackedSeriesData, '', '', '', '');
                this.recentUsageLoaded = true;
            }
        }, error => {
            this.$toasted.show('error');
            this.$announcer.set('Error has occurred.');
        });
    }
}
</script>